var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBootstrapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.277,
    height: 52,
    viewBox: "0 0 65.277 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bootstrap-5-1",
    d: "M13.558,0A6.5,6.5,0,0,0,7.2,6.8,36.546,36.546,0,0,1,6.058,18.178c-1.111,3.6-2.99,5.877-6.058,6.17v3.3c3.069.293,4.947,2.572,6.058,6.17A36.542,36.542,0,0,1,7.2,45.2,6.5,6.5,0,0,0,13.559,52H51.723a6.5,6.5,0,0,0,6.357-6.8,36.546,36.546,0,0,1,1.143-11.383c1.111-3.6,2.985-5.877,6.054-6.17v-3.3c-3.069-.293-4.942-2.572-6.054-6.17A36.54,36.54,0,0,1,58.08,6.8,6.5,6.5,0,0,0,51.723,0H13.558Zm30.7,32.009c0,4.868-3.631,7.82-9.657,7.82H24.34a1.106,1.106,0,0,1-1.106-1.106V13.277A1.106,1.106,0,0,1,24.34,12.17h10.2c5.025,0,8.322,2.722,8.322,6.9a6.179,6.179,0,0,1-5.045,6.019v.153c3.847.422,6.438,3.087,6.438,6.767ZM33.48,15.677H27.631v8.262h4.926c3.808,0,5.908-1.533,5.908-4.274,0-2.569-1.806-3.987-4.985-3.987Zm-5.849,11.54v9.1h6.064c3.965,0,6.065-1.591,6.065-4.581s-2.159-4.524-6.32-4.524H27.631Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrapLogo);
export default __webpack_public_path__ + "static/media/bootstrap-logo.960d688202c843aa2a018d198c5086c7.svg";
export { ForwardRef as ReactComponent };